
export interface AmountConfig {
    amount: number;
    text?: string;
}

// Define the amount configurations
const elevenSeva: AmountConfig = { amount: 11, text: "Seva" };
const twentyOneSeva: AmountConfig = { amount: 21, text: "Aarti Seva" };
const fiftyOneSeva: AmountConfig = { amount: 51, text: "Thal Seva" };
const hundredOneSeva: AmountConfig = { amount: 101, text: "Sabha Seva" };
const hundredFiftyOneSeva: AmountConfig = { amount: 151, text: "Utsav Seva" };
const twoFiftyOneSeva: AmountConfig = { amount: 251, text: "Mahotsav Seva" };

const sydRows = [
   [{ amount: 21, text: "General Donation" }, { amount: 51, text: "One Thal Seva" }],
   [{ amount: 101, text: "Full Day Thal Seva" }, { amount: 151, text: "Weekend Thal Seva" }],
   [{ amount: 201, text: "Weekly One Time Thal" }, { amount: 251, text: "Weekly All Thal Seva" }],
];

const defaultRows = [
    [elevenSeva, twentyOneSeva],
    [fiftyOneSeva, hundredOneSeva],
    [hundredFiftyOneSeva, twoFiftyOneSeva]
];

const canberraRows: AmountConfig[][] = [
    [{ amount: 11, text: "General Donation" }, { amount: 21, text: "General Donation" }],
    [{ amount: 51, text: "Thal Seva" }, { amount: 101, text: "Full Day Thal Seva" }],
    [{ amount: 151, text: "Weekend Thal" }, { amount: 251, text: "Weekend Full Thal " }]
]

const hobartRows: AmountConfig[][] = [
    [{ amount: 11, text: "Seva" }, { amount: 21, text: "Seva" }],
    [{ amount: 51, text: "Seva" }, { amount: 101, text: "Seva" }],
    [{ amount: 151, text: "Seva" }, { amount: 201, text: "Seva" }]
]

const goldCoastRows: AmountConfig[][] = [
    [ elevenSeva, twentyOneSeva],
    [fiftyOneSeva, { amount: 151, text: "Sabha Seva" }],
    [{ amount: 201, text: "Utsav Seva" }, { amount: 351, text: "Mahotsav Seva" }]
]

const cairnsRows: AmountConfig[][] = [
    [{ amount: 51, text: "Sabha Seva" }, { amount: 101, text: "Utsav Seva" }],
    [{ amount: 151, text: "Mahotsav Seva" }, { amount: 251, text: "Grand Annakut" }],
]

const adelaideRows: AmountConfig[][] = [
    [{ amount: 5, text: "Seva" }, { amount: 11, text: "Seva" }],
    [{ amount: 21, text: "Seva" }, { amount: 51, text: "Seva" }],
    [{ amount: 101, text: "Seva" }, { amount: 151, text: "Seva" }]
]

const melbourneSouthRows: AmountConfig[][] = [
    [{ amount: 5, text: "Bhet" }, { amount: 11, text: "Bhet" }],
    [{ amount: 21, text: "Arti" }, { amount: 51, text: "Thal Seva" }],
    [{ amount: 101, text: "Sant Dhotiya" }, { amount: 151, text: "Sant Rasoi" }]
]

const melbourneMandirRows: AmountConfig[][] = [
    [{ amount: 5, text: "Abhishek" }, { amount: 11, text: "Seva" }],
    [{ amount: 25, text: "Arti Seva" }, { amount: 31, text: "Seva" }],
    [{ amount: 51, text: "Thal Seva" }, { amount: 101, text: "Sabha Seva" }]
]

const mtGmbrRows: AmountConfig[][] = [
    [{ amount: 21, text: "Seva" }, { amount: 31, text: "Aarti Seva" }],
    [{ amount: 51, text: "Thal Seva" }, { amount: 101, text: "Sabha Seva" }],
    [{ amount: 151, text: "Utsav Seva" }, { amount: 201, text: "Mahotsav Seva" }]
]

enum TerminalLocation {
    Sydney,
    Canberra,
    GoldCoast,
    Cairns,
    Hobart,
    Adelaide,
    MelbourneSouth,
    MelbourneMandir,
    MtGmbr,
    Other
}

const getTerminalLocation = (location: string): TerminalLocation => {

    if (location.startsWith("mel-south"))
        return TerminalLocation.MelbourneSouth;

    if (location.startsWith("mel-ter"))
        return TerminalLocation.MelbourneMandir;

    if (location.startsWith("syd"))
        return TerminalLocation.Sydney;

    if (location.startsWith("cbr"))
        return TerminalLocation.Canberra;

    if (location.startsWith("gld"))
        return TerminalLocation.GoldCoast;

    if (location.startsWith("crn"))
        return TerminalLocation.Cairns;

    if (location.startsWith("hbt"))
        return TerminalLocation.Hobart;

    if (location.startsWith("adl"))
        return TerminalLocation.Adelaide;

    if (location.startsWith("mt-gmbr"))
        return TerminalLocation.MtGmbr;
    
    else
        return TerminalLocation.Other;

};

export const getDonationRows = (loggedInUserName?: string): AmountConfig[][] => {
    const terminalLocation = getTerminalLocation(loggedInUserName ?? "other");
    switch (terminalLocation) {
        case TerminalLocation.MelbourneSouth:
            return melbourneSouthRows;
        case TerminalLocation.MelbourneMandir:
            return melbourneMandirRows;
        case TerminalLocation.Sydney:
            return sydRows;
        case TerminalLocation.Canberra:
            return canberraRows;
        case TerminalLocation.GoldCoast:
            return goldCoastRows;
        case TerminalLocation.Cairns:
            return cairnsRows;
        case TerminalLocation.Hobart:
            return hobartRows;
        case TerminalLocation.Adelaide:
            return adelaideRows;
        case TerminalLocation.MtGmbr:
            return mtGmbrRows;
        default:
            return defaultRows;
    }
};

